export interface SubTasksResponse {
  success: boolean;
  data: Array<SubTaskItem>;
  total: number;
}

export interface Company {
  id: string;
  name: string;
}

export interface DisplayEntities {
  protectedEntityId: string;
  name: string;
  type: number;
}

export interface Target {
  name: string;
  protectedEntityId: string;
  type: number;
  path?: string;
  serverId?: string | null;
  displayEntities: Array<DisplayEntities>;
  integrationName?: string;
}

export interface ErrorMessageParams {
  code?: string;
  credentials?: any;
  meta?: any;
}

export interface Specifics {
  credentials?: any;
  dataXmlUrl?: string;
  endTime?: string;
  errorCode?: number | string | null;
  errorMessage?: string;
  errorMessageParams?: ErrorMessageParams;
  oemKitId?: number;
  packageUniqueId?: string;
  scheduler?: TasksSchedule;
  startTime?: string;
  supaAttempts?: number;
  supaDetectedOs?: number;
  supaId?: string;
  waitingForKits?: string;
  detectionDate?: string;
  routines?: Array<{ id: number; result: number }>;
  query?: string;
  s3UploadConfig?: {
    fileLocation: string,
    bucket: string,
    region: string
  }
}

export interface TasksSchedule {
  scheduledDeploy: boolean;
  scheduleType: number | null;
  everyHour: number | null;
  startTime: string | null;
  dayOfWeek: number | null;
  nextRun: string | null;
  retries: number | null;
}

export interface SubTaskItem {
  _id: string;
  type: number;
  taskName: string;
  targetsCount: number;
  targets: Array<Target>;
  status: number;
  startDate: string;
  specifics?: Specifics;
  recordSource: number;
  progressPercentage: number;
  progress: number;
  ownerUserName: string;
  ownerId: string;
  companies: Array<Company>;
}

export interface TaskTarget {
  name: string;
  protectedEntityId: string;
  type: number;
  company: Company;
}

export interface TasksStopSpecifics {
  stopTargets: StopTargets[];
}

export interface StopTargets {
  name: string;
  protectedEntityId: string;
  type: number;
  taskId: string;
  taskType: number;
  taskProgress: number;
  taskStatus: number;
}

export interface TaskStopSubTasksRequestData {
  settings: {
    specifics: TasksStopSpecifics;
    targets: TaskTarget[];
    taskName: string;
    type: number;
  };
}

export interface SubTasksStopSubTasksResponseData {
  success: boolean;
}

export enum SubTasksMethod {
  READ_SUBTASKS = 'readSubTasks',
  CREATE_TASKS = 'createTasks',
}
